/**
 * Optymalizator obrazów Next.js (/_next/image) odrzuca dwa rodzaje źródeł
 * i zwraca dla nich HTTP 400, przez co obrazek znika ze strony:
 *
 * - SVG — blokowane, dopóki nie ustawi się images.dangerouslyAllowSVG.
 *   Nie chcemy tego włączać: loga sklepów wgrywają klienci, a SVG może
 *   nieść skrypt.
 * - data: URI — np. awatary trzymane w bazie jako base64 (avatarBase64).
 *
 * Dla takich źródeł trzeba wymusić <Image unoptimized />. Wszystko inne
 * (jpg/png/webp/avif/gif) przechodzi przez optymalizator i jest skalowane
 * do rozmiaru, w jakim faktycznie się renderuje.
 */
export const isUnoptimizable = (src?: string | null): boolean =>
  !src || src.startsWith("data:") || /\.svg($|[?#])/i.test(src);
